// Theme B - New Color Palette
// Primary: #3069b3 (blue)
// Dark Gray: #2d3748
// Navy: #303a4c
// Accent Red: #ef5d50

export const themeBColors = {
  brand: {
    50: '#e8f0fb',
    100: '#c2daf5',
    200: '#99c3ee',
    300: '#70abe7',
    400: '#4e99e1',
    500: '#3069b3', // Primary blue
    600: '#2b5ea0',
    700: '#244f88',
    800: '#1d4070',
    900: '#152f53',
  },
  brandScheme: {
    50: '#e8f0fb',
    100: '#c2daf5',
    200: '#99c3ee',
    300: '#70abe7',
    400: '#4e99e1',
    500: '#3069b3', // Primary blue
    600: '#2b5ea0',
    700: '#244f88',
    800: '#1d4070',
    900: '#152f53',
  },
  brandTabs: {
    50: '#e8f0fb',
    100: '#c2daf5',
    200: '#99c3ee',
    300: '#70abe7',
    400: '#4e99e1',
    500: '#3069b3', // Primary blue
    600: '#2b5ea0',
    700: '#244f88',
    800: '#1d4070',
    900: '#152f53',
  },
  secondaryGray: {
    100: '#E0E5F2',
    200: '#E1E9F8',
    300: '#F4F7FE',
    400: '#E9EDF7',
    500: '#8F9BBA',
    600: '#A3AED0',
    700: '#707EAE',
    800: '#707EAE',
    900: '#2d3748', // Dark gray
  },
  red: {
    100: '#fdecea',
    500: '#ef5d50', // Accent red
    600: '#d94438',
  },
  blue: {
    50: '#e8f0fb',
    500: '#3069b3', // Primary blue
  },
  orange: {
    100: '#FFF6DA',
    500: '#FFB547',
  },
  green: {
    100: '#E6FAF5',
    500: '#01B574',
  },
  navy: {
    50: '#e8ebee',
    100: '#c5cbd3',
    200: '#a1abb8',
    300: '#7d8b9c',
    400: '#5f7186',
    500: '#303a4c', // Navy
    600: '#2a3343',
    700: '#242c3a',
    800: '#1e2531',
    900: '#151b23',
  },
  gray: {
    50: '#f7fafc',
    100: '#edf2f7',
    200: '#e2e8f0',
    300: '#cbd5e0',
    400: '#a0aec0',
    500: '#718096',
    600: '#4a5568',
    700: '#2d3748', // Dark gray
    800: '#1a202c',
    900: '#171923',
  },
  background: {
    100: '#FFFFFF',
    900: '#303a4c', // Navy for dark mode
  },
};
